import { BodyMediumEmphasized, H5Emphasized, YStack } from 'smoothie';

import { formatDollars } from '../../../common/utils/bankingUtils';

interface GoalTargetProps {
    targetAmount: number;
}

const GoalTarget = ({ targetAmount }: GoalTargetProps) => {
    return (
        <YStack
            width="100%"
            padding={12}
            borderWidth={1}
            borderColor="$gray200"
            borderRadius={12}
            flexShrink={1}
            gap={4}
        >
            <BodyMediumEmphasized color="$gray1000">
                Goal target
            </BodyMediumEmphasized>
            <H5Emphasized>{formatDollars(targetAmount, false)}</H5Emphasized>
        </YStack>
    );
};

export default GoalTarget;
